import { Observable } from 'rxjs';

export class Media {
  mediaId: string;
  name: string;
  type: string;
  url?: string;
  url$?: Observable<string>;
}
